import React from 'react'

import type { ExternalSource } from '../../../../../Analytics.types'
import { GoogleAnalyticsReportBottomContent } from '../../../modules/GoogleAnalytics'

export const getExternalSourceBottomContent = (externalSource: ExternalSource, uri?: string) => {
  if (externalSource === 'google-analytics') {
    return <GoogleAnalyticsReportBottomContent href={uri} />
  }
}
